/**
 * The docs bands, in order. Shared with the site header's on-this-page nav, so the anchors and
 * the labels cannot drift apart.
 *
 * No accent on these titles. The marketing headings accent a clause that carries meaning; these
 * are two-word functional labels, where colouring the second word is decoration rather than
 * emphasis. The page takes the brand on its links and its step numerals instead.
 *
 * `kicker` is derived from position rather than written out, so a band that is conditionally
 * rendered cannot leave a gap in the numbering.
 */
const SECTIONS = {
  features: {
    id: 'key-features',
    title: 'Key Features',
    label: 'CAPABILITIES',
    subtitle: 'Ask in plain language. Select a feature to see what it accepts.',
  },
  gettingStarted: {
    id: 'getting-started',
    title: 'Getting Started',
    label: 'SETUP',
    subtitle: 'Three steps, on any MCP-compatible assistant.',
  },
  connect: {
    id: 'connect',
    title: 'Connect',
    label: 'CLIENTS',
    subtitle: 'Pick your client. The server URL is shown above.',
  },
  examples: {
    id: 'try-asking',
    title: 'Try asking',
    label: 'PROMPTS',
    subtitle: 'Example prompts once the server is connected.',
  },
} as const;

export const DOC_SECTIONS = Object.fromEntries(
  Object.entries(SECTIONS).map(([key, section], index) => [
    key,
    { ...section, kicker: `0${index + 1}  /  ${section.label}` },
  ]),
) as { [K in keyof typeof SECTIONS]: (typeof SECTIONS)[K] & { kicker: string } };
